var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconOffice = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 23,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "m19.71 6.28-14-4a.742.742 0 0 0-.66.12c-.19.14-.3.36-.3.6v18c0 .41.34.75.75.75h14c.41 0 .75-.34.75-.75V7a.75.75 0 0 0-.54-.72Zm-9.46 13.97V18c0-.14.11-.25.25-.25h4c.14 0 .25.11.25.25v2.25h-4.5Zm8.5 0h-2.5V18c0-.96-.79-1.75-1.75-1.75h-4c-.96 0-1.75.79-1.75 1.75v2.25h-2.5V3.99l12.5 3.57v12.69Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#2F1F19",
  d: "M8.5 14.75c.41 0 .75-.34.75-.75V9c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75ZM16.5 14.75c.41 0 .75-.34.75-.75V9c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75ZM12.5 14.75c.41 0 .75-.34.75-.75V9c0-.41-.34-.75-.75-.75s-.75.34-.75.75v5c0 .41.34.75.75.75Z"
})));
export default SvgIconOffice;